import React, { useState, useEffect } from "react";
import { Checkbox, Popover, Select, Switch } from "antd";
import { Button, Input } from "antd";
import "./search.scss";
import { useHistory } from "react-router-dom";

const { Option } = Select;

function Searchfields(props) {
  const [userFilter, setuserFilter] = useState([]);
  const [objectLevel, setobjectLevel] = useState([]);

  const query = useHistory().location.search;
  const token = new URLSearchParams(query).get("token");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/users?&token=${token}`)
      .then((res) => res.json())
      .then((response) => {
        setuserFilter(response.data);
      })
      .catch((error) => {
        alert(error.message);
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/levels?&token=${token}`)
      .then((res) => res.json())
      .then((response) => {
        setobjectLevel(response.data);
      })
      .catch((error) => {
        alert(error.message);
      });
  }, []);

  return (
    <div className="px-lg-4 py-4 px-0 search-field m-0">
      <div
        className={`d-flex w-100 sub-header ${
          !props.toggle ? "" : "justify-content-end"
        }`}
      >
        {!props.toggle ? (
          <div className="d-flex align-items-center row flex-1">
            <div className="d-flex align-items-center col-lg-4 col-md-12 pb-lg-0 pb-md-3 pb-3 col-12">
              <div className="pe-2 ps-0 flex-1">
                <Input
                  className="w-100"
                  placeholder={props.placeholder}
                  onChange={props.handleSearch}
                  allowClear
                  data-telemetry={props.placeholder}
                />
              </div>
              <Button onClick={props.handleSearchuser} data-telemetry={props.placeholder}>Search</Button>
            </div>
            <div className="col-lg-4 col-md-6 col-6">
              <Select
                showSearch
                className="w-100"
                placeholder="Select User"
                onChange={props.handleSelect}
                allowClear
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                data-telemetry="Select user to filter objectives"
              >
                {userFilter?.map((listUser) => (
                  <Option key={listUser.id} value={listUser.id}>
                    {listUser.name}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="col-lg-4 col-md-6 col-6">
              <Select
                showSearch
                className="w-100"
                placeholder="Select Level of Hierarchy"
                onChange={props.handleLevelselect}
                allowClear
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                data-telemetry="Select level of hierarchy to filter objectives"
              >
                {objectLevel?.map((level) => (
                  <Option key={level.id} value={level.id}>
                    {level.name}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        ) : (
          <div className="row flex-1 d-flex justify-content-end">
            <div className="col-lg-4 col-md-10 col-12">
              <Select
                showSearch
                className="w-100"
                placeholder="Select Map Type"
                defaultValue={"Objectives"}
                onChange={props.handleMapValue}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                data-telemetry="Select map type to filter objectives"
              >
                <Option key="1" value="objectives">
                  Objectives
                </Option>
                <Option key="2" value="keyResults">
                  Key Results
                </Option>
              </Select>
            </div>
          </div>
        )}
        <div className="d-flex align-items-center">
          <div className="col-lg-11 col-md-11 col-11">
            <Select
              showSearch
              className="w-100"
              placeholder="Select spotlight"
              onChange={props.handleSpotlight}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              data-telemetry="Select spotlight to filter objectives"
            >
              <Option key="1" value="rocketship" keyValue="true">
                <Popover
                  content="Objectives whose outcomes are outperforming timelines by > 20%"
                  title=""
                  trigger="hover"
                  placement="top"
                >
                  Rocketships
                </Popover>
              </Option>
              <Option key="2" value="lossableBet" keyValue="true">
                <Popover
                  content="Total delivered to the Budget requested for individual KeyResults"
                  title=""
                  trigger="hover"
                  placement="bottom"
                >
                  Pilots / Losable Bets
                </Popover>
              </Option>
            </Select>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <p className="f-12 f-w-700 l-h-normal txt-text-1 pe-2">Objectives</p>
          <Switch onChange={props.handleToggle} data-telemetry="Switch objective view to list/heatmap"/>
          <p className="f-12 f-w-700 l-h-normal txt-text-1 ps-2">HeatMap</p>
        </div>
      </div>
    </div>
  );
}

export default Searchfields;
